import { Flex } from '@revenuemarket/cds';
import { Search } from '@revenuemarket/ui/antd/Input';
import { Badge, Typography } from 'antd';

import Chip from '~components/ui/chip';
import { css } from '~libs/emotion';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

import { SettlementStatus } from './utils';

const STATUS_LIST: Record<
  SettlementStatus,
  {
    text: string;
    type: 'success' | 'warning' | 'error';
  }
> = {
  SCHEDULED: {
    text: '정산 예정',
    type: 'warning',
  },
  DELAYED: {
    text: '정산 지연',
    type: 'error',
  },
  DONE: {
    text: '정산 완료',
    type: 'success',
  },
};

interface Props {
  onSearch: (value: string) => void;
  searchParam?: string;
  activeStatus?: SettlementStatus;
  setStatus: (activeStatus?: SettlementStatus) => void;
}

const SettlementListFilter: React.FC<Props> = ({ onSearch, activeStatus, setStatus }) => {
  return (
    <Flex
      justify="space-between"
      style={{
        width: '100%',
      }}
      align="center"
    >
      <Flex gap={10}>
        <Chip
          borderRadius={24}
          active={!activeStatus}
          onClick={() => {
            setStatus(undefined);
          }}
        >
          <Typography.Text
            style={{
              fontSize: 14,
            }}
          >
            전체
          </Typography.Text>
        </Chip>
        {Object.keys(STATUS_LIST).map((status) => {
          return (
            <Chip
              borderRadius={24}
              onClick={() => {
                mixpanel.track(MIXPANEL_EVENT.SETTLEMENT.CLICK_STATUS, {
                  status,
                });
                setStatus(status as SettlementStatus);
              }}
              active={activeStatus === status}
              key={status}
            >
              <Badge
                className={css`
                  & span {
                    font-size: 14px !important;
                  }
                `}
                status={STATUS_LIST[status as SettlementStatus].type}
                text={STATUS_LIST[status as SettlementStatus].text}
              />
            </Chip>
          );
        })}
      </Flex>
      <Search
        size="small"
        placeholder="사업자번호, 거래처, 품목, 금액"
        style={{ width: 200 }}
        onSearchChange={(value) => {
          onSearch(value);
        }}
      />
    </Flex>
  );
};

export default SettlementListFilter;
